import React from "react";
import { VscTrash } from "react-icons/vsc";
import { getDatabase, ref, set, push, child } from "firebase/database";

const NewQuestionComponent = (props) => {
  const handleText = (e) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    tempObject["text"] = e.target.value;

    tempArray[props.index] = tempObject;

    props.objectsSetState(tempArray);
  };

  const handleСorrectOption = (e) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    if (tempObject["correctOption"] !== e) {

      tempObject["correctOption"] = e;
  
      tempArray[props.index] = tempObject;
  
      props.objectsSetState(tempArray);
    } 

  };

  const handleOptions = (e) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    tempObject["options"] = e.target.value.split(", ");

    tempArray[props.index] = tempObject;

    props.objectsSetState(tempArray);
  };

  const handleSingleOption = (e, optionIndex) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    tempObject["options"][optionIndex] = e.target.value;

    tempArray[props.index] = tempObject;

    props.objectsSetState(tempArray);
  };

  const handleInterviewerName = (e) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    tempObject["interviewerName"] = e.target.value;

    tempArray[props.index] = tempObject;

    props.objectsSetState(tempArray);
  };

  const handleInterviewerTitle = (e) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    tempObject["interviewerTitle"] = e.target.value;

    tempArray[props.index] = tempObject;

    props.objectsSetState(tempArray);
  };

  const handleAssetURL = (e) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    tempObject["assetURL"] = e.target.value;

    tempArray[props.index] = tempObject;

    props.objectsSetState(tempArray);
  };

  const handleExplanationAssetURL = (e) => {
    const tempArray = [...props.questionObjects];
    const tempObject = tempArray[props.index];

    tempObject["explanationAssetURL"] = e.target.value;

    tempArray[props.index] = tempObject;

    props.objectsSetState(tempArray);
  };

  const removeQuestion = () => {
    const temp = [...props.questionObjects];

    temp.splice(props.index, 1);
    props.objectsSetState(temp);
  };

  return (
    <div>
      <div className="new-question-header">
        <p>Question {props.index + 1}</p>
        <button
          style={{ background: "none", border: "none", cursor: "pointer" }}
          onClick={() => removeQuestion()}
        >
          <VscTrash color="red" size={20} />
        </button>
      </div>
      <div className="new-question-separator">
        <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
          <input
            className="modal-input"
            placeholder="Text"
            value={props.questionObjects[props.index].text}
            onChange={(e) => handleText(e)}
          />
          {/* <input
            className="modal-input"
            placeholder="Correct Option"
            value={props.questionObjects[props.index].correctOption}
            onChange={(e) => handleСorrectOption(e)}
          />
          <input
            className="modal-input"
            placeholder="Options"
            value={props.questionObjects[props.index].options?.join(", ")}
            onChange={(e) => handleOptions(e)}
          /> */}
          <input
            className="modal-input"
            placeholder="Interviewer Name"
            value={props.questionObjects[props.index].interviewerName}
            onChange={(e) => handleInterviewerName(e)}
          />
          <input
            className="modal-input"
            placeholder="Interviewer Title"
            value={props.questionObjects[props.index].interviewerTitle}
            onChange={(e) => handleInterviewerTitle(e)}
          />
          <input
            className="modal-input"
            placeholder="Asset URL"
            value={props.questionObjects[props.index].assetURL}
            onChange={(e) => handleAssetURL(e)}
          />
          <input
            className="modal-input"
            placeholder="Explanation Asset URL"
            value={props.questionObjects[props.index].explanationAssetURL}
            onChange={(e) => handleExplanationAssetURL(e)}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
          <p style={{ marginBottom: "10px"}}>Options</p>
          <div>
            <input
              type="checkbox"
              name="option"
              checked={props.questionObjects[props.index].correctOption === "1" }
               onChange={() => handleСorrectOption("1")}
               style={{marginRight: "5px"}}
            />
            <input
              className="modal-input"
              placeholder="Option 1"
              value={props.questionObjects[props.index].options[0]}
              onChange={(e) => handleSingleOption(e, 0)}
            />
          </div>
          <div>
            <input
              type="checkbox"
              name="option"
              checked={props.questionObjects[props.index].correctOption === "2" }
              onChange={() => handleСorrectOption("2")}
              style={{marginRight: "5px"}}
            />
            <input
              className="modal-input"
              placeholder="Option 2"
              value={props.questionObjects[props.index].options[1]}
              onChange={(e) => handleSingleOption(e, 1)}
            />
          </div>
          <div>
            <input
              type="checkbox"
              name="option"
              checked={props.questionObjects[props.index].correctOption === "3" }
              onChange={() => handleСorrectOption("3")}
              style={{marginRight: "5px"}}
            />
            <input
              className="modal-input"
              placeholder="Option 3"
              value={props.questionObjects[props.index].options[2]}
              onChange={(e) => handleSingleOption(e, 2)}
            />
          </div>
          <div>
            <input
              type="checkbox"
              name="option"
              checked={props.questionObjects[props.index].correctOption === "4" }
              onChange={() => handleСorrectOption("4")}
              style={{marginRight: "5px"}}
            />
            <input
              className="modal-input"
              placeholder="Option 4"
              value={props.questionObjects[props.index].options[3]}
              onChange={(e) => handleSingleOption(e, 3)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewQuestionComponent;
